module.exports = __webpack_public_path__ + "media/images/icon_a3-f8399eb0dd968d0cd08db901681f53f3.png";